module.exports = __webpack_public_path__ + "static/diagram_validity_rules-268d81f49ada34791230c8a4953edccd.png";